import React, { useEffect, useRef } from "react";
import "./Grow.css";
import gsap from "gsap";
import Arrow from "../../assets/image/arrow-one.png";
import ArrowSecond from "../../assets/image/arrow-two.png";
import AOS from "aos";
import "aos/dist/aos.css";

const Grow = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease",
    });
  }, []);

  const circleRef = useRef(null); // Ref for the animated element

  useEffect(() => {
    const tl = gsap.timeline({ repeat: 100, yoyo: true });

    tl.to(circleRef.current, {
      y: -1500,
      duration: 5,
      ease: "in",
    })
      .to(circleRef.current, {
        opacity: 0,
        // visibility: 'hidden', // Mengatur opacity menjadi 0
        duration: 1,
        // delay: .1, // Delay sebelum opacity diubah menjadi 0
      })
      .to(circleRef.current, {
        y: -1500, // Mengembalikan posisi gambar ke awal
        opacity: 0,
        // visibility: 'visible', // Mengembalikan opacity ke 1
        duration: 1,
        // delay: .2,
        onComplete: () => {
          tl.play(0); // Mulai ulang animasi
        },
      });
  }, []);

  const circleRefs = useRef(null); // Ref for the animated element

  useEffect(() => {
    const tl = gsap.timeline({ repeat: 100, yoyo: true });

    tl.to(circleRefs.current, {
      y: -1500,
      duration: 5,
      ease: "in",
    })
      .to(circleRefs.current, {
        opacity: 0,
        // visibility: 'hidden', // Mengatur opacity menjadi 0
        duration: 1,
        // delay: .1, // Delay sebelum opacity diubah menjadi 0
      })
      .to(circleRefs.current, {
        y: -1500, // Mengembalikan posisi gambar ke awal
        opacity: 0,
        // visibility: 'visible', // Mengembalikan opacity ke 1
        duration: 1,
        delay: 1,
        onComplete: () => {
          tl.play(0); // Mulai ulang animasi
        },
      });
  }, []);

  return (
    <div className='container-growUp'>
      <div className='title-grow'>
        <p>mundu is</p>
      </div>
      <div className='content-growUp'>
        <p className='title-one'>
          A GROWING <span className='font-border'>NEIGHBORHOOD</span>
        </p>
        <p className='font-border'>socially, culturally</p>
        <p>AND NATIONALLY</p>
        <div className='article'>
          <p data-aos='fade-up'>
            "Kami hadir untuk mewujudkan era digital, menjadikan segalanya lebih
            sederhana, serta merintis masa depan yang lebih baik bagi
            lingkungan."
          </p>
        </div>
      </div>

      <div className='container-img' ref={circleRef}>
        <img src={Arrow} alt='' srcSet='' className='img-one' />
      </div>
      <div className='container-img-right' ref={circleRefs}>
        <img src={ArrowSecond} alt='' srcSet='' className='img-two' />
      </div>
    </div>
  );
};

export default Grow;
